// import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { secureBusinessKey, apiEndpoints } from "../.info";
import Cookies from "js-cookie";
import { Bounce, toast } from "react-toastify";

import { fetchEmployees, fetchSpecialists } from "../api/employees";

export const getEmployeesAndSpecialists = createAsyncThunk(
  "emploees/getEmployeesAndSpecialists",
  async ({ serviceId, duration }, { rejectWithValue }) => {
    try {
      // console.log("duration1", duration);
      const branchId = Cookies.get("brunch_id");

      const personal_token = Cookies.get("personal_token");

      const sessionExpired = (msg) => {
        toast(msg, {
          style: {
            background: "#f87171",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "2rem",
            padding: "1rem",
            width: "20dvh",
          },
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
          transition: Bounce,
          closeButton: ({ closeToast }) => (
            <button
              className="text-white text-4xl leading-none rounded-full p-2"
              onClick={closeToast}
            >
              ×
            </button>
          ),
        });
      };

      if (!branchId || !personal_token) {
        sessionExpired("Session has expired");
        console.log("sss");
        setTimeout(() => {
          window.location.href = "/logout";
        }, 3000);
        return Promise.reject(
          new Error("Branch ID is missing. Redirecting to logout.")
        );
      }
      // Fetch all employees
      const employeeResponse = await fetchEmployees({ serviceId });

      // Extract employee IDs
      const employees = employeeResponse.data?.response || [];
      const employeeIds = employees?.map((employee) => employee?.user_id);
      sessionStorage.setItem("employee_user_ids", JSON.stringify(employeeIds));
      const cartItems = JSON.parse(sessionStorage.getItem("cartItems")) || {};
      const filteredEmployeeIds = employeeIds?.filter(
        (id) => !cartItems?.professionals_id?.includes(id)
      );

      // console.log("filteredEmployeeIds", filteredEmployeeIds);

      // Fetch available specialists
      const specialistResponse = await fetchSpecialists(
        // filteredEmployeeIds,
        employeeIds,
        duration
      );
      console.log(specialistResponse?.data, "specialistResponse");
      if (
        !specialistResponse?.data?.status &&
        specialistResponse?.data?.data == "user not found, check your token"
      ) {
        sessionExpired("Session has expired");

        setTimeout(() => {
          window.location.href = "/logout";
        }, 3000);
        return Promise.reject(
          new Error("Branch ID is missing. Redirecting to logout.")
        );
      }

      const availableIds = new Set(
        specialistResponse?.data?.data.map((specialist) => specialist)
      );

      // Filter the employees to include only those who are available
      const availableEmployees = employees?.filter((employee) =>
        availableIds?.has(employee.user_id)
      );

      return {
        availableEmployees: availableEmployees,
        allSpecialistsData: specialistResponse.data,
      };
    } catch (error) {
      console.error("Error fetching data:", error);

      return rejectWithValue(error.message);
    }
  }
);

const getEmploeesSlice = createSlice({
  name: "emploees",
  initialState: {
    availableEmployees: [],
    allSpecialistsData: null,
    status: "idle", // idle | loading | succeeded | failed
    isError: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmployeesAndSpecialists.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getEmployeesAndSpecialists.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.availableEmployees = action.payload.availableEmployees;
        state.allSpecialistsData = action.payload.allSpecialistsData;
      })
      .addCase(getEmployeesAndSpecialists.rejected, (state, action) => {
        state.status = "failed";
        state.isError = action.payload;
      });
  },
});

export const getEmploeesReducer = getEmploeesSlice.reducer;
